import React from 'react';
import { useTranslation } from 'react-i18next';
import { SiteArea } from 'graphql-common';
import Typography from '@lib/components/Typography/Typography';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import { materialSymbolsOutlined } from '@lib/enums/common';
import TextEditor from '@lib/components/TextEditor/TextEditor';
import entityViewStyles from '@lib/assets/styles/EntityView.module.scss';

interface Props {
  areaData?: SiteArea;
  onEdit: () => void;
}

function AreaView(props: Props) {
  const { t } = useTranslation();
  const { areaData, onEdit } = props;
  const { code, description, address } = areaData || {};
  return (
    <>
      <div className={entityViewStyles.infoList}>
        <div className={entityViewStyles.infoItem}>
          <p className={entityViewStyles.infoItemLabel}>
            <MaterialIcon icon="password" symbolsOutlined />
            <Typography variant="caption">{t('code')}</Typography>
          </p>
          <div className={entityViewStyles.infoItemContent}>
            <Typography variant="body">{code}</Typography>
          </div>
        </div>
        <div className={entityViewStyles.infoItem}>
          <p className={entityViewStyles.infoItemLabel}>
            <MaterialIcon icon="distance" symbolsOutlined />
            <Typography variant="caption">{t('address')}</Typography>
          </p>
          <div className={entityViewStyles.infoItemContent}>
            <Typography variant="body">{address}</Typography>
          </div>
        </div>
        {!!description && (
          <>
            <div className={entityViewStyles.infoItem}>
              <p className={entityViewStyles.infoItemLabel}>
                <MaterialIcon icon="description" symbolsOutlined />
                <Typography variant="caption">{t('description')}</Typography>
              </p>
            </div>
            <TextEditor
              readOnly
              value={description}
              className={entityViewStyles.description}
            />
          </>
        )}
      </div>
      <Button
        buttonText={t('edit-site-area')}
        buttonType={ButtonTypes.primaryOutlined}
        leftIcon="edit"
        leftIconClassName={materialSymbolsOutlined}
        onClick={onEdit}
        fullWidth
      />
    </>
  );
}

export default AreaView;
